import React from 'react';
import { formatNumber } from '../../helpers/formatNumber';

export const MapVolumeInfo = ({ confirmedVolumeM3, totalVolumeM3, car }) => {
  const capacity = car ? ` / ${formatNumber(car.capacity)}m³` : '';

  return (
    <div className="d-flex flex-column map-info-box">
      <div className="map-info-box__section-title">{__('volumes.volumes')}</div>
      <div>Potw.: {formatNumber(confirmedVolumeM3)}m³{capacity}</div>
      <div>Łącz.: {formatNumber(totalVolumeM3)}m³{capacity}</div>
    </div>
  );
};
